import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { useState } from 'react';
import {
  getEvaluationResult,
  EvaluationResultAnalysisPayload,
} from '../reducers/postEvaluationResultAnalysis';

const usePostEvaluationResultAnalysis = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>();

  const postResultAnalysisSurvey = async (
    requestPayload: EvaluationResultAnalysisPayload,
  ) => {
    try {
      const resultAction = await dispatch(getEvaluationResult(requestPayload));
      if (getEvaluationResult.fulfilled.match(resultAction)) {
        setLoading(false);
      }
    } catch (error) {
      setError(error);
    }finally{
      setLoading(false)
    }
  };

  return { loading, error, postResultAnalysisSurvey };
};

export default usePostEvaluationResultAnalysis;
